// src/components/home/RequestResetPage.js
import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

const RequestResetPage = () => {
  const API_PREFIX = '/api';
  const { theme } = useTheme();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('initial'); // initial, loading, success, error
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setError('');

    try {
      const response = await fetch(API_PREFIX + '/auth/request-reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      if (!response.ok) {
        throw new Error('Failed to send reset email');
      }

      setStatus('success');
    } catch (err) {
      setStatus('error');
      setError(err.message);
    }
  };

  if (status === 'success') {
    return (
      <div 
        className="min-h-screen flex flex-col relative overflow-hidden"
        style={{ backgroundColor: theme.mainPanelBg }}
      >
        <div className="flex-1 flex flex-col items-center justify-center text-center p-6">
          <Mail size={64} style={{ color: theme.buttonBg }} className="mb-8" />
          <h1 
            className="text-4xl font-bold mb-4"
            style={{ color: theme.mainPanelText }}
          >
            Check Your Email
          </h1>
          <p 
            className="mb-8 max-w-md"
            style={{ color: theme.mainPanelText }}
          >
            If an account exists with this email, we've sent password reset instructions.
          </p>
          <Link
            to="/login"
            className="px-6 py-3 rounded-lg font-semibold"
            style={{ backgroundColor: theme.buttonBg, color: theme.buttonText }}
          >
            Return to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: theme.mainPanelBg }}
    >
      <div className="max-w-md w-full p-8 rounded-lg">
        <h1 
          className="text-3xl font-bold mb-8 text-center"
          style={{ color: theme.mainPanelText }}
        >
          Reset Password
        </h1>
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label 
              htmlFor="email" 
              className="block text-sm font-medium mb-2"
              style={{ color: theme.mainPanelText }}
            >
              Email address
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2"
              style={{ 
                backgroundColor: theme.inputBg,
                borderColor: theme.inputBorder,
                color: theme.inputText
              }}
              required
            />
          </div>

          {error && (
            <div className="text-red-500 text-sm">{error}</div>
          )}

          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full py-2 px-4 rounded-md font-medium focus:outline-none focus:ring-2 transition duration-150"
            style={{
              backgroundColor: theme.buttonBg,
              color: theme.buttonText,
              opacity: status === 'loading' ? 0.7 : 1
            }}
          >
            {status === 'loading' ? 'Sending...' : 'Send Reset Link'}
          </button>

          <div className="mt-4 text-center">
            <Link 
              to="/login" 
              className="font-medium"
              style={{ color: theme.accentColor }}
            >
              Back to Login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RequestResetPage;